import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '@/components/ui/button';
import { Loader2, CheckCircle, XCircle, Mail } from 'lucide-react';

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [verifying, setVerifying] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (token) {
      verifyEmail();
    } else {
      setVerifying(false);
      setError('No verification token provided');
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      await axios.post(`${API}/auth/verify-email`, { token });
      setSuccess(true);
      toast.success('Email verified successfully!');
    } catch (err) {
      setError(err.response?.data?.detail || 'Verification failed');
      toast.error('Verification failed');
    }
    setVerifying(false);
  };

  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      
      <main className="pt-32 pb-16 flex items-center justify-center min-h-screen">
        <div className="w-full max-w-md px-6">
          <div className="bg-[#111] border border-white/10 rounded-sm p-8 text-center">
            {verifying ? (
              <div className="py-8">
                <Loader2 className="w-16 h-16 text-[#CCFF00] mx-auto mb-4 animate-spin" />
                <h2 className="text-xl font-bold text-white mb-2">Verifying Email...</h2>
                <p className="text-white/50">Please wait while we verify your email address.</p>
              </div>
            ) : success ? (
              <div className="py-8">
                <CheckCircle className="w-16 h-16 text-[#CCFF00] mx-auto mb-4" />
                <h2 className="text-xl font-bold text-white mb-2">Email Verified!</h2>
                <p className="text-white/50 mb-6">
                  Your email has been successfully verified. You can now access all features.
                </p>
                <Button
                  onClick={() => navigate('/dashboard')}
                  className="bg-[#CCFF00] text-black hover:bg-[#B3E600] font-bold uppercase rounded-none"
                >
                  Go to Dashboard
                </Button>
              </div>
            ) : (
              <div className="py-8">
                <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
                <h2 className="text-xl font-bold text-white mb-2">Verification Failed</h2>
                <p className="text-white/50 mb-6">{error}</p>
                <div className="space-y-3">
                  <Link to="/login">
                    <Button className="w-full bg-[#CCFF00] text-black hover:bg-[#B3E600] font-bold uppercase rounded-none">
                      Sign In
                    </Button>
                  </Link>
                  <p className="text-white/30 text-sm">
                    Need a new verification email? Sign in and request one from your dashboard.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default VerifyEmailPage;
